<template>
    <div class="d-flex flex-column">
        <v-row ref="headerFilters">
            <data-table-filters v-if="!isMobile"
                :name="$t('orders.pendingCarts.title')"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    :name="$t('orders.pendingCarts.title')"
                    :has-active-filters="hasActiveFilters"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    :filters="filters"
                    :schema="tSchema(schema)"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh"
                    @clear-filters="onClearFilters"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col>
                <pure-datatable endpoint="/api/orders/pending-carts" :ready="ready" ref="datatable" @data-changed="dataChanged" v-slot:default="{ vOn, vBind, updateOptions, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="pending_carts"
                            class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :headers="tHeaders(headers)"
                            :header-props="headerProps"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions: itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                        >
                             <template #[`item.id`]="{ item }">
                                <div class="d-flex align-center">
                                    {{ item.id }}
                                </div>
                            </template>
                            <template #[`item.branch_id`]="{ item }">
                                <div class="d-flex align-center">
                                    {{ item.branch.id }}
                                </div>
                            </template>
                            <template #[`item.name`]="{ item }">
                                <div class="d-flex align-center datatable-designation-text">
                                    {{ item.branch.name }}
                                </div>
                            </template>
                            <template #[`item.user_name`]="{ item }">
                                <div class="d-flex align-center datatable-designation-text">
                                    {{ item.user.name }}
                                </div>
                            </template>
                            <template #[`item.created_at`]="{ item }">
                                <div class="d-flex align-center">
                                    {{ formatDateTime(item.created_at) }}
                                </div>
                            </template>

                            <template #[`item.actions`]="{ item }">
                                <div class="d-flex justify-end align-center">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs" small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color" style="cursor: pointer" @click="loadCart(item)" data-cy="view-order">mdi-dots-horizontal-circle-outline</v-icon>
                                        </template>
                                        <span>{{ $t('orders.pendingCarts.loadCart') }}</span>
                                    </v-tooltip>
                                </div>
                            </template>

                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="false" :show-order-button="false" :scope="scope" @updateOptions="refresh" :isLoading="isLoading" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>
        <confirmation-dialog
            :value="isLoadCartDialogOpen"
            :isLoading="isLoading"
            @onSuccess="initiatePendingCartMode(selectedCart)"
            @onCancel="isLoadCartDialogOpen = false"
            :title="$t('layout.attention')"
            :question="$t('orders.pendingCarts.startViewModeQuestion')"
            width="40vw"
        >
        </confirmation-dialog>
        <confirmation-dialog
            :value="isChangeBranchDialogOpen"
            :isLoading="isLoading"
            @onSuccess="changeBranch(selectedCart)"
            @onCancel="isChangeBranchDialogOpen = false"
            :title="$t('layout.attention')"
            :question="$t('orders.pendingCarts.switchClientQuestion')"
            width="40vw"
        >
        </confirmation-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import PureDatatable from '@arentia/atools/PureDatatable';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import { axios } from '@/Services/Backend';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],

        // Receiving the table data for cart details here aswell
        details_headers: [Object, Array],
    },

    data: () => ({
        isLoading: false,
        datatableSize: 200,
        resizeObserver: null,

        ready: false,
        selectedCart: null,
        isLoadCartDialogOpen: false,
        isChangeBranchDialogOpen: false,

        filters: {},
        hasExpandedActiveFilters: false,
        itemsPerPageOptions: [20,40,50],//window.innerWidth <= 1024?[20,50,100]:[10,20,50],
        first:false
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.ready = true;
                this.refresh();
            },
            immediate: true,
        },
    },
    created() {
        if(this.isMobile){
            this.getPrefilledBranches()
        }else{
            this.applyDefaultFilters();
        }
    },

    mounted() {
        this.prepareResponsiveBehaviour();
        if(!this.isMobile){
            this.refresh();
        }
        window.EventBus.$on('refresh-pending-carts', () => {
            this.refresh();
        });
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
                 this.refreshDeely()
        });
        /*window.EventBus.$on('updated-product-stocks', ({ data }) => {
            this.products.forEach((product, index) => {
                const productStock = data.find((p) => p.code == product.code);
                if (productStock && product.has_current_stock != productStock.has_current_stock) {
                    this.$set(this.products[index], 'has_current_stock', productStock.has_current_stock);
                    this.$set(this.selectedProduct, 'has_current_stock', productStock.has_current_stock);
                }
            });
        });*/
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
        window.EventBus.$off('updated-product-stocks');
        //window.EventBus.$off('refresh-pending-carts');
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore,useAppStore, useNormalOrderStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        canApproveCart() {
            return this.userStore.hasPermissionTo('Approve cart');
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },
    watch: {
    'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                //this.queryParams.branch_id = branch.id;
               // this.refresh(true);
                if(!this.isMobile){
                    //this.refresh();
                    this.ready = true;
                    this.refresh();
                }else{
                    if(this.first){
                        this.ready = true;
                        this.refresh();
                    }else{
                        this.getPrefilledBranches()
                    }
                }
            },
            immediate: true,
        },
    },
    methods: {
        getPrefilledBranches(){
             axios
                .get('/api/branches/prefilled-branches')
                .then((response) => {
                       let result = response.data
                       this.model['branch__id']=[];
                       for(let field in result){
                          this.model['branch__id'].push({id:result[field].id})
                       }
                       this.applyDefaultFilters();
                        if(!this.first){
                                this.$nextTick(_=>{
                                    this.first=true
                                    this.refresh()
                                })
                        }
                }).catch((error) => {
                    console.log(error);
                });
        },
        setItemsPorPage(){
            this.itemsPerPageOptions=[20,40,50]//window.innerWidth<=1024?[20,50,100]:[10,20,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        dataChanged() {
            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },

        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh();
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },
        refresh(options) {
            if (!this.branchStore.branch) return;

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                    options=this.$refs.datatable.localOptions
                    options.itemsPerPage=window.innerWidth>=768&&window.innerWidth<=1366?20:20
                    this.$refs.datatable.setLocalOptions(options);
                }
                this.$refs.datatable.onChangeQueryBuilder(this.filters, this.schema);
            }
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh();
        },

        changeBranch(basicPendingCart) {
            axios
                .get(`/api/branches/single/${basicPendingCart.branch.id}/`)
                .then(({ data }) => {
                    this.branchStore.setBranchNotify(data, this.$inertia, this.userStore.user?.id, this.userStore.user?.seller_id);
                })
                .catch((error) => {
                    console.error(error);
                    this.isChangeBranchDialogOpen = false;
                    this.showError(this.$t('orders.pendingCarts.loadClientError'));
                });
        },

        initiatePendingCartMode(basicPendingCart) {
            // basicPendingCart name used to differentiate this initial data (from the table listing) from full valid data for a pending cart

            axios
                .get(`/api/branches/single/${basicPendingCart.branch.id}/`)
                .then(({ data }) => {
                    // Disable syncing
                    this.normalOrderStore.setIsPendingCart(true);
                    this.normalOrderStore.setPendingCartId(basicPendingCart.id);

                    // Set branch, which will also obtain the target pending cart
                    this.branchStore.setBranchNotify(data, this.$inertia, this.userStore.user?.id, this.userStore.user?.seller_id, basicPendingCart.id);
                    this.isLoadCartDialogOpen = false;

                    this.showSuccess(this.$t('orders.pendingCarts.viewModeStarted', { id: basicPendingCart.id }));
                })
                .catch((error) => {
                    console.error(error);
                    this.isLoadCartDialogOpen = false;
                    this.showError(this.$t('orders.pendingCarts.loadClientError'));
                });
        },
        loadCart(cart) {
            this.selectedCart = cart;

            // Force the user to swap to the correct branch before proceeding
            if (this.branchStore.branch.id != cart.branch.id) {
                this.isChangeBranchDialogOpen = true;
                return;
            }

            this.isLoadCartDialogOpen = true;
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>
